import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
const Withdrawal = () => {
    useEffect(() => {
        document.title = 'Withdrawal -  Sacred Heart School, Ballia - U.P.';  
    }, []);  
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Withdrawal </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Admission</li>
                            <li>|</li>
                            <li> Withdrawal </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                       <div className="col-lg-12">
                           <ul className="list">
                                <li> Every Application for a school leaving certificate shall be made in writing by the parent/guardian on the prescribed form.</li>
                                <li> A school leaving certificate will not be issued until all the fees are paid. Those who leave in April will pay the fees for May and June as well. </li>
                                <li>  A fee of Rs. 50/- will be charged for a transfer certificate and this will be issued only two days after the receipt of application. </li>
                                <li>  The issue of T.C. implies that all dues to and from the school are completely cleared.</li>
                           </ul>
                       </div>
                </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default Withdrawal